import {cacheImageDataUrl, convertBase64ToDataUrl} from '@/services/tierImageService'

export function transformTierDataToForm(tierData, formatMessage) {
  const formData = {
    name: tierData.name || '',
    tierId: String(tierData.tierID || tierData.tierId || ''),
    activities: tierData.activities?.map(activity => ({
      activityID: String(activity.activityID || ''),
      activityName: activity.activityName,
      multiplier: activity.multiplier,
    })) || [],
    content: {}
  }

  const defaultLanguages = [
    formatMessage({ id: 'LANGUAGES.ENGLISH_ID' }),
    formatMessage({ id: 'LANGUAGES.SPANISH_MEXICO_ID' })
  ]

  if (tierData.content && Object.keys(tierData.content).length > 0) {
    Object.keys(tierData.content).forEach(langKey => {
      const content = tierData.content[langKey]
      if (content.imageTierIconObject?.id && content.imageTierIconObject?.data) {
        const dataUrl = convertBase64ToDataUrl(content.imageTierIconObject.data)
        cacheImageDataUrl(content.imageTierIconObject.id, dataUrl)
      }
      if (content.bannerImageObject?.id && content.bannerImageObject?.data) {
        const dataUrl = convertBase64ToDataUrl(content.bannerImageObject.data)
        cacheImageDataUrl(content.bannerImageObject.id, dataUrl)
      }
      if (content.detailsImageObject?.id && content.detailsImageObject?.data) {
        const dataUrl = convertBase64ToDataUrl(content.detailsImageObject.data)
        cacheImageDataUrl(content.detailsImageObject.id, dataUrl)
      }
      formData.content[langKey] = {
        tierName: content.tierName || tierData.name || '',
        displayDescription: content.displayDescription || '',
        imageTierIcon: content.imageTierIconObject?.id || content.imageTierIcon || '',
        bannerHeader: content.bannerHeader || '',
        bannerDescription: content.bannerDescription || '',
        bannerImage: content.bannerImageObject?.id || content.bannerImage || '',
        detailsDescription: content.detailsDescription || '',
        detailsTermsAndConditions: content.detailsTermsAndConditions || '',
        detailsImage: content.detailsImageObject?.id || content.detailsImage || '',
      }
    })
  } else {
    defaultLanguages.forEach(langKey => {
      formData.content[langKey] = {
        tierName: tierData.name || '',
        displayDescription: '',
        imageTierIcon: '',
        bannerHeader: '',
        bannerDescription: '',
        bannerImage: '',
        detailsDescription: '',
        detailsTermsAndConditions: '',
        detailsImage: '',
      }
    })
  }

  return formData
}
